import { TypedDocumentNode, gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import {
  RivalsUpdateFavoriteTeam,
  RivalsUpdateFavoriteTeamVariables,
} from './__generated__/useFootballRivalsUpdateFavoriteTeam.graphql';

const UPDATE_FAVORITE_TEAM = gql`
  mutation RivalsUpdateFavoriteTeam(
    $input: footballRivalsUpdateFavoriteTeamInput!
  ) {
    footballRivalsUpdateFavoriteTeam(input: $input) {
      currentManager {
        id
        favoriteTeam {
          slug
        }
      }
      errors {
        code
        path
      }
    }
  }
` as TypedDocumentNode<
  RivalsUpdateFavoriteTeam,
  RivalsUpdateFavoriteTeamVariables
>;

export const useFootballRivalsUpdateFavoriteTeam = () => {
  return useMutation(UPDATE_FAVORITE_TEAM);
};
